import { render, staticRenderFns } from "./PerformanceStatisticList.vue?vue&type=template&id=c0911464&scoped=true"
import script from "./PerformanceStatisticList.vue?vue&type=script&lang=js"
export * from "./PerformanceStatisticList.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStatisticList.vue?vue&type=style&index=0&id=c0911464&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0911464",
  null
  
)

export default component.exports